const LOGOS = [
  "SAP", "Workday", "Bosch", "ING", "Siemens", "BMW", "ASML", "Vodafone",
  "Adidas", "BNP Paribas", "Allianz", "Philips",
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="border-y border-slate-200 bg-white py-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-6">
          Trusted by European tech & enterprise leaders
        </div>
        <div className="overflow-hidden no-scrollbar">
          <div className="flex gap-12 animate-marquee whitespace-nowrap">
            {[...LOGOS, ...LOGOS].map((l, i) => (
              <div
                key={i}
                className="text-slate-400 hover:text-slate-700 transition-colors font-display font-bold text-2xl tracking-tight"
              >
                {l}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
